import Vue from 'vue';
import {DirectiveDefinitionDisableIfEmbedded} from '@customer-portal/shared/src/directives';

Vue.directive('disable-if-embedded', DirectiveDefinitionDisableIfEmbedded);
